import styled, { css } from 'styled-components';
import { f as focusOutline } from '../../theme/style-mixins/FocusIndicator/focusOutline-oDdaDZ4N.js';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const MenuItem = /*#__PURE__*/styled('li').attrs({
  role: 'menuitem'
}).withConfig({
  componentId: "sc-storm-ui-40026394__sc-1ruhcn9-0"
})(["list-style-type:none;text-align:start;"]);
MenuItem.displayName = 'MenuItem';
const BaseMenuItemMixin = /*#__PURE__*/css(["display:inline-block;box-sizing:border-box;width:100%;text-align:start;border:none;&&{padding-block:", ";padding-inline:", ";", "}:focus-visible{", " &&{outline-offset:0;}}"], ({
  theme
}) => theme.controls.paddingBlock.base.default, ({
  theme
}) => theme.controls.paddingInline.xlarge.default, isMobile(css(["padding-block:", ";padding-inline:", ";"], ({
  theme
}) => theme.controls.paddingBlock.base.mobile, ({
  theme
}) => theme.controls.paddingInline.xlarge.mobile)), focusOutline);

export { BaseMenuItemMixin as B, MenuItem as M };
//# sourceMappingURL=MenuItem.styles-Dkrv2sP6.js.map
